import store from './redux'

export default {
	open: args => {
    store.dispatch({
      'type': 'open',
      'args': args
    })
  }
}
